import { Image, StepBar } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import { AppLoader } from '@hero/components/atoms';
import { AppNavigation } from '@hero/components/molecules';

import { Footer } from '../Footer';

import * as S from './style';

function GeneralLayout({ children, steps, activeStepIndex, isLoading }) {
  return (
    <S.Layout stepsLength={steps?.length}>
      <AppNavigation />
      <S.LayoutHeader>
        <S.LayoutHeaderContainer>
          <Image name="logo" alt="Layout logo" height={32} />
          {steps && (
            <StepBar
              steps={steps}
              activeStepIndex={activeStepIndex}
              direction="horizontal"
              labelPosition="end"
            />
          )}
        </S.LayoutHeaderContainer>
      </S.LayoutHeader>
      <S.LayoutBody>
        <S.LayoutBodyInner>{children}</S.LayoutBodyInner>
        <Footer />
      </S.LayoutBody>
      {isLoading && <AppLoader />}
    </S.Layout>
  );
}

export { GeneralLayout };

GeneralLayout.propTypes = {
  children: PropTypes.node,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      isCompleted: PropTypes.bool
    })
  ),
  activeStepIndex: PropTypes.number,
  isLoading: PropTypes.bool
};
